import Vue from 'vue'
import App from './app.vue'
import ViewUI from 'view-design'
import { router } from './router/index'
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css'
import './theme.less'
import Ajax from './lib/ajax'
import Util from './lib/util'
import axios from 'axios'
import AppConsts from './lib/appconst'
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper'
import VDistpicker from 'v-distpicker'
import VueAreaLinkage from 'vue-area-linkage'
import VueAMap from 'vue-amap'
import VueClipboard from 'vue-clipboard2'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueClipboard)
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '6fbd581128d4694f3286d2cba4541f0c',
  plugin: [
    'Autocomplete',
    'PlaceSearch',
    'Scale',
    'OverView',
    'ToolBar',
    'MapType',
    'PolyEditor',
    'AMap.CircleEditor',
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
})
Vue.use(VueAreaLinkage)
Vue.component('v-distpicker', VDistpicker)
Vue.filter('formatPrice', function (price) {
  return '￥' + Number(price).toFixed(2)
})
Vue.filter('formatTwo', function (obj) {
  return Number(obj).toFixed(2)
})
Vue.filter('percent', function (obj) {
  return (Number(obj) * 100).toFixed(0) + '%'
})
Vue.use(ViewUI, {
  transfer: true,
  size: 'small',
})

Vue.use(VueQuillEditor, {
  placeholder: '请输入',
  modules: {
    toolbar: [
      [
        'bold',
        'italic',
        'underline',
        'strike',
        { color: [] },
        { background: [] },
        'clean',
        { font: [] },
        { size: ['small', false, 'large', 'huge'] },
      ], // toggled buttons
      [
        { align: [] },
        { list: 'ordered' },
        { list: 'bullet' },
        { indent: '-1' },
        { indent: '+1' },
        { direction: 'rtl' },
        'blockquote',
      ],
    ],
  },
})

import store from './store/index'
// 将store弄到全局变量那里
window.suStore = store
Vue.config.productionTip = false

import { appRouters, otherRouters } from './router/router'
if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
  let language = navigator.language
  abp.utils.setCookieValue(
    'Abp.Localization.CultureName',
    language,
    new Date(new Date().getTime() + 5 * 365 * 86400000),
    abp.appPath
  )
}
console.log('main获取跟路由', appRouters);
// if (localStorage.getItem('access_token')) {
Ajax.get(`/api/abp/application-configuration`, {
  baseURL: AppConsts.token_root,
}).then((res) => {
  // console.log('第一次登录获取lieb', res, appRouters);
  Util.extend(true, Util.abp.auth.allPermissions, res.data.auth.policies)
  Util.extend(
    true,
    Util.abp.auth.grantedPermissions,
    res.data.auth.grantedPolicies
  )
  new Vue({
    render: (h) => h(App),
    router: router,
    store: store,
    data: {
      currentPageName: '',
    },
    async mounted() {
      this.currentPageName = this.$route.name as string

      this.$store.commit('app/initCachepage')
      this.$store.commit('app/updateMenulist')
    },
    created() {
      let tagsList: Array<any> = []
      // console.log('54645654', appRouters);
      appRouters.map((item) => {
        if (item.children.length <= 1) {
          tagsList.push(item.children[0])
        } else {
          tagsList.push(...item.children)
        }
      })
      this.$store.commit('app/setTagsList', tagsList)

    },
  }).$mount('#app')
})
// }

